import React from 'react';
import { Drawer } from 'vaul';
import EventApplyPage from '../pages/EventApplyPage';

/**
 * Bottom sheet that shows a single event without leaving the page you're on.
 * Open/close is driven by the parent (the featured wall ties it to a
 * `?event=CODE` history entry, so the back button closes it and re-opens it on
 * forward; the curator queue just holds it in state). The event view is the real
 * EventApplyPage rendered in `embedded` mode (no Navbar), so it's exactly what
 * the public sees.
 *
 * Mobile keeps the full-width sheet and the drag handle — that's the native
 * gesture. On desktop it narrows to the event column's own 630px and gains an
 * explicit close button, because there's no swipe-to-dismiss with a mouse and a
 * full-width sheet on a wide screen is just a bad page.
 */
export default function MobileEventSheet({ code, open, onClose }) {
  return (
    <Drawer.Root open={open} onOpenChange={(next) => { if (!next) onClose(); }}>
      <Drawer.Portal>
        <Drawer.Overlay className="fixed inset-0 safe-inset z-[60] bg-black/50" />
        <Drawer.Content
          // inset-x-0 + max-w + mx-auto centres on desktop WITHOUT a transform —
          // vaul writes its drag animation to the inline transform, so a
          // translate-based centring would be overridden mid-drag and snap the
          // sheet to the left edge.
          className="fixed inset-x-0 bottom-0 safe-bottom-inset z-[61] flex h-[93vh] flex-col rounded-t-2xl border-t-2 border-black bg-white outline-none md:mx-auto md:max-w-[630px] md:border-x-2 md:border-black"
          aria-describedby={undefined}
        >
          {/* Grab handle */}
          <div className="mx-auto mt-2 mb-1 h-1.5 w-12 flex-shrink-0 rounded-full bg-gray-300" />

          {/* Desktop-only close. Mobile dismisses by dragging the handle, so an X
              there would be redundant chrome over the poster. */}
          <button
            type="button"
            onClick={onClose}
            aria-label="Close"
            className="absolute right-3 top-3 z-10 hidden h-8 w-8 items-center justify-center border-2 border-black bg-white font-mono text-sm font-bold leading-none text-black hover:bg-black hover:text-white md:flex"
          >
            ×
          </button>

          <Drawer.Title className="sr-only">Event details</Drawer.Title>
          {/* The page owns its scroller: title strip and CTA bar are flex children above and
              below it, never sticky inside it — Android's WebView paints sticky chrome inside
              a nested scroller a few px adrift (content peeks over the strip, a band opens
              under the bar). */}
          <div className="flex min-h-0 flex-1 flex-col">
            {code && <EventApplyPage inviteCode={code} embedded />}
          </div>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  );
}
